import { Component, OnInit } from '@angular/core';
import { FilterModel } from 'src/Models/filterModel';
import { CheckAuth } from 'src/Services/utility.service';
import { Title } from '@angular/platform-browser';
import { LifelineNLADClaimService } from 'src/Services/nladClaim.service';
import { InrollProductsCompanyModel } from 'src/Models/InrollProductsCompanyModel';
import { ClaimStateModel } from 'src/Models/ClaimStateModel';
import { EBBClaimProcessDetailsModel } from 'src/Models/EBBClaimProcessDetailsModel';
import * as FileSaver from 'file-saver';
import { ToastrService } from 'ngx-toastr';
import { SessionStorageService } from 'src/common/session-storage.service';

@Component({
  selector: 'app-view-claim-process-details-lifeline',
  templateUrl: './view-claim-process-details-lifeline.component.html',
  styleUrls: ['./view-claim-process-details-lifeline.component.css']
})
export class ViewClaimProcessDetailsLifelineComponent implements OnInit {
  filterModel = new FilterModel();
  listOfData: EBBClaimProcessDetailsModel[];
  listOfExportData: EBBClaimProcessDetailsModel[];
  tokenKey: string = '';
  _userID: any;

  currentPage: number = 1;
  totalRecordCount: number = -1;
  keywordFilter: string = '';
  OrderBy: string = '';
  isAscending: boolean = false

  upDowSubscriberIDCSS: string = '';
  upDowRateCSS: string = '';
  upDowReasonCodeCSS: string = '';
  upDowTribalLinkUpChargesWaivedCSS: string = '';
  upDowSPINCSS: string = '';
  upDowSACCSS: string = '';
  upDowLastNameCSS: string = '';
  upDowFirstNameCSS: string = '';
  upDowStreetAddressCSS: string = '';
  upDowCityCSS: string = '';
  upDowStateCSS: string = '';
  upDowZipCSS: string = '';
  upDowPhoneNumberCSS: string = '';
  upDowETCGeneralCSS: string = '';
  upDowServiceTypeCSS: string = '';
  upDowTribalBenefitFlagCSS: string = '';
  upDowCreatedDateCSS: string = '';
  upDowYearsCSS: string = '';
  upDowMonthsCSS: string = '';

  dropdownMonths = [];
  selectedItemsMonths = [];
  dropdownSettingMonths = {};
  listOfMonths = [];

  dropdownYears = [];
  selectedItemsYears = [];
  dropdownSettingYears = {};
  listOfYears = [];
  monthText = [];

  listOfInrollProductCompany: InrollProductsCompanyModel[];
  dropdownCompanies = [];
  selectedItemsCompanies = [];
  dropdownSettingCompanies = {};
  listOfCompany = [];

  listOfStateData: ClaimStateModel[];
  dropdownStates = [];
  selectedItemsStates = [];
  dropdownSettingStates = {};
  listOfStates = [];

  companyName: string = '';
  isShowprogressSpinner: boolean;
  blockedDocument: boolean = false;
  isloading = false;

  constructor(private readonly nladClaimService: LifelineNLADClaimService, 
    private readonly checkAuth: CheckAuth, 
    private readonly titleService: Title,
    private readonly toastr: ToastrService,
    private sessionStorageService: SessionStorageService
  ) {
    this.tokenExpireCalculation(this.sessionStorageService.getAppStartTime(),this.sessionStorageService.getTokenExpiryValue());
    this._userID = sessionStorage.getItem('UserId');
    this.tokenKey = this.sessionStorageService.getTokenValue();
    this.titleService.setTitle('View Lifeline Claim Details');
  }

  tokenExpireCalculation(startDate: string, tokenExpiry: string) {
    this.checkAuth.tokenExpireCalculation(startDate, tokenExpiry);
  }
  ngOnInit() {
    this.currentPage=1;
    this.filterModel.pageNumber = '1';
    this.filterModel.pageSize = '10';
    this.filterModel.orderBy = 'Id';
    this.filterModel.userID = this._userID;
    this.filterModel.productId = 0;
    this.filterModel.months = '0';
    this.filterModel.years = '0';
    this.filterModel.state = '';
    if (sessionStorage.getItem('ViewClaimMasterId') != null)
      this.filterModel.claimMasterId = sessionStorage.getItem('ViewClaimMasterId');
    if (sessionStorage.getItem('ViewCompanyName') != null)
      this.companyName = sessionStorage.getItem('ViewCompanyName');
    this.LifelineClaimDetailsReports();    
    this.GetClaimState();

    this.monthText.push({ 'id': 1, 'itemName': 'January' });
    this.monthText.push({ 'id': 2, 'itemName': 'February' });
    this.monthText.push({ 'id': 3, 'itemName': 'March' });
    this.monthText.push({ 'id': 4, 'itemName': 'April' });
    this.monthText.push({ 'id': 5, 'itemName': 'May' });
    this.monthText.push({ 'id': 6, 'itemName': 'June' });
    this.monthText.push({ 'id': 7, 'itemName': 'July' });
    this.monthText.push({ 'id': 8, 'itemName': 'August' });
    this.monthText.push({ 'id': 9, 'itemName': 'September' });
    this.monthText.push({ 'id': 10, 'itemName': 'October' });
    this.monthText.push({ 'id': 11, 'itemName': 'November' });
    this.monthText.push({ 'id': 12, 'itemName': 'December' });
  }

  LifelineClaimDetailsReports() {
    
    this.blockDocument();
    this.listOfData = [];
    this.isloading = true;
    this.filterModel.IsExport=false;
    this.nladClaimService.ViewLifelineClaimProcessDetailsPagedV2(this.tokenKey, this.filterModel).subscribe(
      data => {
        this.isloading = false;
        this.unblockDocument();
        if (data != null) {
          this.listOfData = data['listOfData'];
          if (this.listOfData != null) {
            if (this.listOfData.length > 0) {
              this.totalRecordCount = this.listOfData[0].totalRecords;
            }
            else
              this.totalRecordCount = 0;
          }
          else
            this.totalRecordCount = 0;
        }
      },
      error => {
        this.isloading = false;
        this.unblockDocument();
        console.log(error);
      }
    );
  }

  pageChanged($event: any) {
    this.filterModel.pageNumber = $event.page;
    this.currentPage = $event.page;
    this.LifelineClaimDetailsReports();
  }

  sort(sortBy: any) {
  this.upDowSubscriberIDCSS = '';
  this.upDowRateCSS = '';
  this.upDowReasonCodeCSS = '';
  this.upDowTribalLinkUpChargesWaivedCSS = '';
  this.upDowSPINCSS = '';
  this.upDowSACCSS = '';
  this.upDowLastNameCSS = '';
  this.upDowFirstNameCSS = '';
  this.upDowStreetAddressCSS = '';
  this.upDowCityCSS = '';
  this.upDowStateCSS = '';
  this.upDowZipCSS = '';
  this.upDowPhoneNumberCSS = '';
  this.upDowETCGeneralCSS = '';
  this.upDowServiceTypeCSS = '';
  this.upDowTribalBenefitFlagCSS = '';
  this.upDowCreatedDateCSS = '';
  this.upDowYearsCSS = '';
  this.upDowMonthsCSS = '';

  if (!this.isAscending) {
    this.isAscending = true;
    this.filterModel.orderBy = sortBy + ' DESC';

    if (sortBy === 'subscriberID') this.upDowSubscriberIDCSS = 'fa fa-arrow-down';
    else if (sortBy === 'rate') this.upDowRateCSS = 'fa fa-arrow-down';
    else if (sortBy === 'reasonCode') this.upDowReasonCodeCSS = 'fa fa-arrow-down';
    else if (sortBy === 'tribalLinkUpChargesWaived') this.upDowTribalLinkUpChargesWaivedCSS = 'fa fa-arrow-down';
    else if (sortBy === 'spin') this.upDowSPINCSS = 'fa fa-arrow-down';
    else if (sortBy === 'sac') this.upDowSACCSS = 'fa fa-arrow-down';
    else if (sortBy === 'lastName') this.upDowLastNameCSS = 'fa fa-arrow-down';
    else if (sortBy === 'firstName') this.upDowFirstNameCSS = 'fa fa-arrow-down';
    else if (sortBy === 'streetAddress') this.upDowStreetAddressCSS = 'fa fa-arrow-down';
    else if (sortBy === 'city') this.upDowCityCSS = 'fa fa-arrow-down';
    else if (sortBy === 'state') this.upDowStateCSS = 'fa fa-arrow-down';
    else if (sortBy === 'zip') this.upDowZipCSS = 'fa fa-arrow-down';
    else if (sortBy === 'phoneNumber') this.upDowPhoneNumberCSS = 'fa fa-arrow-down';
    else if (sortBy === 'etcGeneral') this.upDowETCGeneralCSS = 'fa fa-arrow-down';
    else if (sortBy === 'serviceType') this.upDowServiceTypeCSS = 'fa fa-arrow-down';
    else if (sortBy === 'tribalBenefitFlag') this.upDowTribalBenefitFlagCSS = 'fa fa-arrow-down';
    else if (sortBy === 'createdDate') this.upDowCreatedDateCSS = 'fa fa-arrow-down';
    else if (sortBy === 'years') this.upDowYearsCSS = 'fa fa-arrow-down';
    else if (sortBy === 'months') this.upDowMonthsCSS = 'fa fa-arrow-down';

  } else {
    this.isAscending = false;
    this.filterModel.orderBy = sortBy;

    if (sortBy === 'subscriberID') this.upDowSubscriberIDCSS = 'fa fa-arrow-up';
    else if (sortBy === 'rate') this.upDowRateCSS = 'fa fa-arrow-up';
    else if (sortBy === 'reasonCode') this.upDowReasonCodeCSS = 'fa fa-arrow-up';
    else if (sortBy === 'tribalLinkUpChargesWaived') this.upDowTribalLinkUpChargesWaivedCSS = 'fa fa-arrow-up';
    else if (sortBy === 'spin') this.upDowSPINCSS = 'fa fa-arrow-up';
    else if (sortBy === 'sac') this.upDowSACCSS = 'fa fa-arrow-up';
    else if (sortBy === 'lastName') this.upDowLastNameCSS = 'fa fa-arrow-up';
    else if (sortBy === 'firstName') this.upDowFirstNameCSS = 'fa fa-arrow-up';
    else if (sortBy === 'streetAddress') this.upDowStreetAddressCSS = 'fa fa-arrow-up';
    else if (sortBy === 'city') this.upDowCityCSS = 'fa fa-arrow-up';
    else if (sortBy === 'state') this.upDowStateCSS = 'fa fa-arrow-up';
    else if (sortBy === 'zip') this.upDowZipCSS = 'fa fa-arrow-up';
    else if (sortBy === 'phoneNumber') this.upDowPhoneNumberCSS = 'fa fa-arrow-up';
    else if (sortBy === 'etcGeneral') this.upDowETCGeneralCSS = 'fa fa-arrow-up';
    else if (sortBy === 'serviceType') this.upDowServiceTypeCSS = 'fa fa-arrow-up';
    else if (sortBy === 'tribalBenefitFlag') this.upDowTribalBenefitFlagCSS = 'fa fa-arrow-up';
    else if (sortBy === 'createdDate') this.upDowCreatedDateCSS = 'fa fa-arrow-up';
    else if (sortBy === 'years') this.upDowYearsCSS = 'fa fa-arrow-up';
    else if (sortBy === 'months') this.upDowMonthsCSS = 'fa fa-arrow-up';
  }

  this.currentPage = 1;
  this.filterModel.pageNumber = '1';
  this.LifelineClaimDetailsReports();
}


  setMonthsText(id) {
    return this.monthText.filter(m => m.id == id)[0].itemName;
  }

  removeElemetninArrayById(array, element) {
    return array.filter(e => e.id !== element);
  }

  GetClaimState() {
    this.nladClaimService.GetClaimLifelineState(this.tokenKey).subscribe(
      data => {
        if (data != null) {
          this.listOfStateData = data['listOfData'];
          if (this.listOfStateData != null) {
            if (this.listOfStateData.length > 0) {
              
              for (let iCounter = 0; iCounter < this.listOfStateData.length; iCounter++) {
                this.dropdownStates.push({ 'id': this.listOfStateData[iCounter].shortName, 'itemName': this.listOfStateData[iCounter].name });
              }
            }
          }
          this.dropdownSettingStates = {
            singleSelection: true,
            text: 'Select State',
            enableSearchFilter: true,
            classes: 'borderLessTextBoxGreen',
            badgeShowLimit: 1,
            noDataLabel: 'No State',
            showCheckbox: false,
            enableFilterSelectAll: false
          };
        }
      },
      error => {
        console.log(error);
      }
    );
  }

  onSelectedStates($event) {
    this.listOfStates = this.removeElemetninArrayById(this.listOfStates, $event.id)
    this.listOfStates.push($event.id);
    this.currentPage=1;
    this.filterModel.pageNumber = '1';
    this.filterModel.state = $event.id;
    this.LifelineClaimDetailsReports();
  }

  onDeSelectedStates($event) {
    if (this.listOfStates != null) {
      if (this.listOfStates.length > 0) {
        this.listOfStates = this.removeElemetninArrayById(this.listOfStates, $event.id)
      }
    }
    this.currentPage=1;
    this.filterModel.pageNumber = '1';
    this.filterModel.state = $event.id;
    this.LifelineClaimDetailsReports();
  }

  onSelectAllStates($event) {
     for (const item of $event) {
      if (this.listOfStates != null) {
        if (this.listOfStates.length > 0) {
          this.listOfStates = this.removeElemetninArrayById(this.listOfStates, item.id)
          this.listOfStates.push(item.id);
        }
        else {
          this.listOfStates.push(item.id);
        }
      }
    }
    this.currentPage=1;
    this.filterModel.pageNumber = '1';
    this.filterModel.state = $event[0].id;
    this.LifelineClaimDetailsReports();
  }

  onDeSelectAllStates($event) {
    this.listOfStates = [];
    this.currentPage=1;
    this.filterModel.pageNumber = '1';
    this.filterModel.state = '';
    this.LifelineClaimDetailsReports();
  }

  blockDocument() {
    this.isShowprogressSpinner = true;
    this.blockedDocument = true;
  }

  unblockDocument() {
    this.isShowprogressSpinner = false;
    this.blockedDocument = false;
  }

  ExportViewLifelineClaimDetails() {
    this.blockDocument();
    this.listOfExportData = [];
    this.isloading = true;
    this.filterModel.IsExport=true;
    this.nladClaimService.ViewLifelineClaimProcessDetailsPagedV2(this.tokenKey, this.filterModel).subscribe(
      data => {
        if (data != null) {
          this.listOfExportData = data['listOfData'];
          if (this.listOfExportData != null) {
            if (this.listOfExportData.length > 0) {
              setTimeout(() => {
              this.DownloadViewLifelineClaimDetails();
              this.unblockDocument();
              this.isloading = false;
            }, 2000);
            }
            else{
              this.unblockDocument();
              this.isloading = false;
            this.toastr.error("No record found", "Error");
            }
          }
          else{
            this.unblockDocument();
            this.isloading = false;
            this.toastr.error("No record found", "Error");
          }            
        }
      },
      error => {
        this.isloading = false;
        this.unblockDocument();
        console.log(error);
      }
    );
  }

  DownloadViewLifelineClaimDetails() {
    let tableData = document.getElementById("ExportTable").innerHTML;

    var uri = 'data:application/vnd.ms-excel;base64,'
      , template = '<html xmlns:o="urn:schemas-microsoft-com:office:office" xmlns:x="urn:schemas-microsoft-com:office:excel" xmlns="http://www.w3.org/TR/REC-html40"><head><!--[if gte mso 9]><xml><x:ExcelWorkbook><x:ExcelWorksheets><x:ExcelWorksheet><x:Name>{worksheet}</x:Name><x:WorksheetOptions><x:DisplayGridlines/></x:WorksheetOptions></x:ExcelWorksheet></x:ExcelWorksheets></x:ExcelWorkbook></xml><![endif]--><meta http-equiv="content-type" content="text/plain; charset=UTF-8"/></head><body>{table}</body></html>'
      , base64 = function (s) { return window.btoa(unescape(encodeURIComponent(s))) }
      , format = function (s, c) { return s.replace(/{(\w+)}/g, function (m, p) { return c[p]; }) }
    let html = "<table><tr class='mainhead'> <td colspan='3'>";
    html += tableData;
    html += "</td></tr></table>";
    let name = 'ExportViewLifelineClaimDetails';
    var ctx = { worksheet: name || 'Worksheet', table: html }
    FileSaver.saveAs((uri + base64(format(template, ctx))), "ExportViewLifelineClaimDetails.xls");
  }
}
